import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

export default function JsonDialog({open, setOpen, detail, setDetail, onApply}) {


  return (
    <>
      <Button variant="contained" onClick={() => setOpen(true)}>
        Paste JSON
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Paste JSON</DialogTitle>

        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={20}
            maxRows={30}
            value={detail}
            onChange={(e) => setDetail(e.target.value)}
            placeholder="Paste your JSON here..."
            variant="outlined"
            sx={{
              mt: 1,
              "& textarea": {
                fontFamily: "monospace",
                fontSize: 13,
              },
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={onApply}>
            Import
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}